// eventService.ts

import api from "@/services/api";

export interface CreateEventSubscriptionPayload {
  email: string;
  topics?: string[];
}

export interface EventSubscriptionData {
  email: string;
  topics: string[];
  createdAt: string;
}

export interface EventSubscriptionResponse {
  success: boolean;
  message: string;
  data: EventSubscriptionData;
}

const eventService = {
  /**
   * Register and save an email address to MongoDB for event notifications on specified topics
   */
  subscribe: async (payload: CreateEventSubscriptionPayload): Promise<EventSubscriptionResponse> => {
    const response = await api.post<EventSubscriptionResponse>("/events/subscribe", payload);
    return response.data;
  },
};

export default eventService;
